import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
    selector: 'header-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

    @ViewChild('searchModal') public searchModal:ModalDirective;

    constructor(private element: ElementRef) { }

    ngOnInit() { }

    onModalShown() {
        let input = this.element.nativeElement.querySelector('.header-input-search')
        if(input) input.focus();
    }
}



// WEBPACK FOOTER //
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/layout/header/search/search.component.ts